import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const QuillEditor = forwardRef(({ value, onChange, modules, formats, placeholder, readOnly, theme = 'snow', className, preserveWhitespace = true, ...props }, ref) => {
  const quillRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getEditor: () => quillRef.current?.getEditor(),
    focus: () => quillRef.current?.focus(),
    blur: () => quillRef.current?.blur(),
  }));

  return (
    <ReactQuill
      ref={quillRef}
      value={value}
      onChange={onChange}
      modules={modules}
      formats={formats}
      placeholder={placeholder}
      readOnly={readOnly}
      theme={theme}
      className={className}
      preserveWhitespace={preserveWhitespace}
      {...props}
    />
  );
});

QuillEditor.displayName = 'QuillEditor';

export default QuillEditor;
